module.exports = __webpack_public_path__ + "img/arbre_fleuri-mobile.ce66f5d4.webp";